import { Theme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  tabbar: {},
  createRoot: {
    marginTop: theme.spacing(3),
  },
  minimumStoryText: {
    marginRight: theme.spacing(3),
    color: '#ff0000',
    fontSize: '0.8rem',
  },
  giftboxTitleGrid: {
    paddingLeft: theme.spacing(2),
  },
  editRoot: {
    marginTop: theme.spacing(3),
  },
  cancelButton: {
    color: '#aaaaaa',
    marginRight: theme.spacing(1),
  },
  underline: {
    '&:focus': {
      '&:before': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  listRoot: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  listPaper: {
    marginBottom: theme.spacing(3),
  },
  listPaperTitle: {
    padding: theme.spacing(2),
  },
  editCard: {
    position: 'absolute',
    right: theme.spacing(3),
    bottom: theme.spacing(5),
    width: '460px',
    height: '310px',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  dialogContent: {
    color: '#777777',
  },
  dialogCancelButton: {
    color: '#888888',
  },
  dialogActions: {
    paddingBottom: theme.spacing(3),
  },
  storyTableRow: {
    '&:hover': {
      backgroundColor: '#F5F5F5',
      cursor: 'pointer',
    },
  },
  editCardContainer: {
    position: 'relative',
    height: '100%',
  },
  editCardButtonContainer: {
    position: 'absolute',
    bottom: 0,
    right: theme.spacing(3),
  },
  storyIdGrid: {
    position: 'relative',
  },
  storyTitle: {
    position: 'absolute',
    color: '#888888',
    right: theme.spacing(5),
    marginTop: -theme.spacing(3),
    maxWidth: '55%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  storyError: {
    position: 'absolute',
    color: 'red',
    right: theme.spacing(5),
    marginTop: -theme.spacing(3),
    maxWidth: '55%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  hideButton: {
    color: '#aaaaaa',
  },
  giftboxStoryListBox: {
    width: '100%',
    overflow: 'scroll',
  },
}));

export default useStyles;
